import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { SortConfig } from '@shared/components/ui/VirtualTable';
import { useTranslation } from 'react-i18next';
import { Entry } from '../../../models';
import { EntryCard } from './EntryCard';

export interface EntryCardListProps {
  entries: Entry[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: SortConfig | null;
  onSortingChange?: (sorting: SortConfig | null) => void;
  total?: number;
  isTenant3pl?: boolean;
  onCancelEntry?: (entry: Entry) => void;
  canCancel?: boolean;
  estimateItemHeight?: number;
}

export const EntryCardList = ({
  entries,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
  total,
  className = '',
  isTenant3pl = false,
  onCancelEntry,
  canCancel = false,
  estimateItemHeight = 200,
}: EntryCardListProps) => {
  const { t } = useTranslation('merchandiseV3');

  const renderEntryCard = (props: RenderItemProps<Entry>) => (
    <EntryCard {...props} isTenant3pl={isTenant3pl} onCancelEntry={onCancelEntry} canCancel={canCancel} />
  );

  const getEntryKey = (entry: Entry) => entry.id;

  return (
    <VirtualList
      data={entries}
      renderItem={renderEntryCard}
      itemKey={getEntryKey}
      estimateItemHeight={estimateItemHeight}
      height="calc(100vh - 220px)"
      gap={12}
      emptyMessage={t('list.empty.title', 'No hay entradas')}
      className={`rounded-lg shadow-sm ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      sorting={sorting}
      onSortingChange={onSortingChange}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
